import React from "react";
import PropTypes from "prop-types";
import OfferCard from "./OfferCard";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const OffersList = (props) => {
    const {offers, title, onShow, onModify, onDelete} = props;

    return (
        <Box sx={{pb: 5}}>
            {
                title &&
                <Box sx={{mb: 3}}>
                    <Typography variant='h4' color="textSecondary" gutterBottom>
                        {title}
                    </Typography>
                </Box>
            }
            <Grid container spacing={2}>
                {
                    offers.map((o) => {
                        return (
                            <Grid key={o.id} xs={12} sm={6} md={4} lg={3} item>
                                <OfferCard offer={o}
                                           onShow={onShow}
                                           onModify={onModify}
                                           onDelete={onDelete}/>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </Box>
    )
};

OffersList.propTypes = {
    offers: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string,
    onShow: PropTypes.func.isRequired,
    onModify: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default OffersList;